import React from 'react';

const AccordionUpArrow = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.7673 9.4617C11.9288 9.30006 12.1981 9.30006 12.3596 9.4617L17.8788 15.0383C18.0404 15.1999 18.0404 15.4693 17.8788 15.6309L17.2865 16.2236C17.1247 16.3853 16.8555 16.3853 16.6942 16.2236L12.3596 11.8324C12.1981 11.6708 11.9288 11.6708 11.7673 11.8324L7.4324 16.1967C7.27113 16.3583 7.0019 16.3583 6.8401 16.1967L6.24806 15.604C6.11344 15.4424 6.11344 15.1999 6.24806 15.0383L11.7673 9.4617Z"
      className={className}
    />
  </svg>
);

const AccordionDownArrow = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.2327 15.228C12.0712 15.3896 11.8019 15.3896 11.6404 15.228L6.12115 9.65143C5.95962 9.4898 5.95962 9.2204 6.12115 9.05876L6.71346 8.46608C6.87527 8.30444 7.1445 8.30444 7.30577 8.46608L11.6404 12.8573C11.8019 13.0189 12.0712 13.0189 12.2327 12.8573L16.5676 8.49302C16.7289 8.33138 16.9981 8.33138 17.1599 8.49302L17.7519 9.0857C17.8866 9.24734 17.8866 9.4898 17.7519 9.65143L12.2327 15.228Z"
      className={className}
    />
  </svg>
);

const NavigationStepsActiveSVG = ({
  activeBgClassName,
  activeOutlineClassName,
}) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.5 9C0.5 4.30739 4.30739 0.5 9 0.5C13.6926 0.5 17.5 4.30739 17.5 9C17.5 13.6926 13.6926 17.5 9 17.5C4.30739 17.5 0.5 13.6926 0.5 9Z"
      //fill="#007E33"
      className={activeBgClassName}
      //stroke="#007E33"
    />
    <path
      d="M8.25625 12.9187L13.5437 7.6125C13.9187 7.2375 13.9188 6.65625 13.5625 6.28125C13.1875 5.90625 12.6062 5.90625 12.2312 6.28125L7.6 10.9125L5.6125 8.925C5.2375 8.55 4.65625 8.55 4.28125 8.925C3.90625 9.3 3.90625 9.88125 4.28125 10.2563L6.94375 12.9187C7.1125 13.1062 7.35625 13.2 7.6 13.2C7.84375 13.2 8.0875 13.0875 8.25625 12.9187Z"
      //fill="white"
      className={activeOutlineClassName}
    />
  </svg>
);
const NavigationStepsSuccessSVG = ({
  successBgClassName,
  successOutlineClassName,
}) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.5 9C0.5 4.30739 4.30739 0.5 9 0.5C13.6926 0.5 17.5 4.30739 17.5 9C17.5 13.6926 13.6926 17.5 9 17.5C4.30739 17.5 0.5 13.6926 0.5 9Z"
      //fill="#E9FFF3"
      //stroke="#007E33"
      className={successBgClassName}
    />
    <path
      d="M8.25625 12.9187L13.5437 7.6125C13.9187 7.2375 13.9188 6.65625 13.5625 6.28125C13.1875 5.90625 12.6062 5.90625 12.2312 6.28125L7.6 10.9125L5.6125 8.925C5.2375 8.55 4.65625 8.55 4.28125 8.925C3.90625 9.3 3.90625 9.88125 4.28125 10.2563L6.94375 12.9187C7.1125 13.1062 7.35625 13.2 7.6 13.2C7.84375 13.2 8.0875 13.0875 8.25625 12.9187Z"
      //fill="#007E33"
      className={successOutlineClassName}
    />
  </svg>
);
const NavigationStepsBeforeActiveSVG = ({
  inactiveClassNameBg,
  inactiveClassNameOutline,
}) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.5 9C0.5 4.30739 4.30739 0.5 9 0.5C13.6926 0.5 17.5 4.30739 17.5 9C17.5 13.6926 13.6926 17.5 9 17.5C4.30739 17.5 0.5 13.6926 0.5 9Z"
      //stroke="#818285"
      className={inactiveClassNameOutline}
    />
    <path
      d="M8.25625 12.9187L13.5437 7.6125C13.9187 7.2375 13.9188 6.65625 13.5625 6.28125C13.1875 5.90625 12.6062 5.90625 12.2312 6.28125L7.6 10.9125L5.6125 8.925C5.2375 8.55 4.65625 8.55 4.28125 8.925C3.90625 9.3 3.90625 9.88125 4.28125 10.2563L6.94375 12.9187C7.1125 13.1062 7.35625 13.2 7.6 13.2C7.84375 13.2 8.0875 13.0875 8.25625 12.9187Z"
      //fill="#818285"
      className={inactiveClassNameBg}
    />
  </svg>
);

const PlusSVG = ({ className }) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.0399 5.95406H8.04566V1.95986C8.04566 1.6825 7.93548 1.4165 7.73935 1.22037C7.54323 1.02424 7.27723 0.914062 6.99986 0.914062C6.7225 0.914062 6.4565 1.02424 6.26037 1.22037C6.06424 1.4165 5.95406 1.6825 5.95406 1.95986V5.95406H1.95986C1.6825 5.95406 1.4165 6.06424 1.22037 6.26037C1.02424 6.4565 0.914062 6.7225 0.914062 6.99986C0.914062 7.27723 1.02424 7.54323 1.22037 7.73935C1.4165 7.93548 1.6825 8.04566 1.95986 8.04566H5.95406V12.0399C5.95406 12.1772 5.98111 12.3132 6.03367 12.4401C6.08623 12.567 6.16326 12.6822 6.26037 12.7794C6.35748 12.8765 6.47277 12.9535 6.59965 13.0061C6.72653 13.0586 6.86253 13.0857 6.99986 13.0857C7.1372 13.0857 7.27319 13.0586 7.40007 13.0061C7.52696 12.9535 7.64224 12.8765 7.73935 12.7794C7.83647 12.6822 7.9135 12.567 7.96606 12.4401C8.01861 12.3132 8.04566 12.1772 8.04566 12.0399V8.04566H12.0399C12.3172 8.04566 12.5832 7.93548 12.7794 7.73935C12.9755 7.54323 13.0857 7.27723 13.0857 6.99986C13.0857 6.7225 12.9755 6.4565 12.7794 6.26037C12.5832 6.06424 12.3172 5.95406 12.0399 5.95406Z"
      fill="none"
      className={className}
    />
  </svg>
);

const EnrollmentLifeEventIcon = ({ primaryClassName1, primaryClassName2 }) => (
  <svg
    width="74"
    height="74"
    viewBox="0 0 74 74"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.6859 39.6106C21.2379 39.615 20.876 39.9822 20.876 40.4337V45.7692C20.876 46.2172 21.2379 46.5826 21.6859 46.5826H39.7857V44.9452H22.509V41.2445H38.7008L37.0758 39.6106H21.6859Z"
      //fill="#5B2540"
      className={primaryClassName1}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.5072 8.32495C16.2691 8.33022 16.0451 8.43036 15.8888 8.60956L5.75096 20.5227C5.62359 20.6737 5.5498 20.8617 5.5498 21.0576V65.0163C5.5542 65.4642 5.9161 65.8297 6.3641 65.8297L47.0831 65.8666C47.5311 65.8666 47.8983 65.5011 47.8983 65.0479V58.8673L46.2653 57.7184V64.2336L7.18454 64.1958V21.8737H17.9487C18.3975 21.8693 18.7594 21.5118 18.7594 21.0576V13.4637C18.7674 13.0025 18.3931 12.631 17.9302 12.6397C17.4875 12.645 17.1256 13.0148 17.1309 13.4637V20.2389H8.16222L16.8823 9.95442H46.2645V34.8575L47.8974 33.814V9.14891C47.8974 8.69652 47.5303 8.33022 47.0823 8.32495H16.5072Z"
      //fill="#5B2540"
      className={primaryClassName1}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.8993 51.0625C11.4452 51.0625 11.0797 51.428 11.085 51.8821V57.2167C11.0797 57.6638 11.4452 58.0354 11.8993 58.0354H17.5721C18.0263 58.0354 18.3917 57.6691 18.3917 57.2167V51.8821C18.3917 51.4244 18.0263 51.0581 17.5721 51.0625H11.8993ZM12.718 52.6902H16.7578V56.3954H12.718V52.6902Z"
      //fill="#E87823"
      className={primaryClassName2}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.8993 39.6106C11.4504 39.6106 11.085 39.9769 11.085 40.4258V45.7692C11.085 46.2172 11.4451 46.5791 11.8993 46.5826H17.5721C18.0209 46.5826 18.3916 46.2172 18.3916 45.7692V40.4258C18.3916 39.9778 18.0209 39.6106 17.5721 39.6106H11.8993ZM12.7179 41.2445H16.7578V44.9496H12.7179V41.2445Z"
      //fill="#E87823"
      className={primaryClassName2}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.8993 26.8367C11.4452 26.8411 11.0797 27.2109 11.085 27.6606V32.9953C11.0797 33.4485 11.4452 33.8139 11.8993 33.8139H17.5721C18.0263 33.8139 18.3917 33.4485 18.3917 32.9953V27.6606C18.3917 27.2065 18.0263 26.8367 17.5721 26.8367H11.8993ZM12.718 28.474H16.7578V32.1766H12.718V28.474Z"
      //fill="#E87823"
      className={primaryClassName2}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.6863 26.8367C21.2383 26.8411 20.8711 27.2109 20.8711 27.6606V32.9953C20.8711 33.4485 21.2383 33.8139 21.6863 33.8139H41.5517C41.9997 33.8139 42.3704 33.4485 42.3704 32.9953V27.6606C42.3704 27.2065 41.9997 26.8367 41.5517 26.8367H21.6863ZM22.5093 28.474H40.7365V32.1766H22.5093V28.474Z"
      //fill="#5B2540"
      className={primaryClassName1}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.6859 51.0581C21.2379 51.0625 20.876 51.4323 20.876 51.8821V57.2167C20.876 57.6691 21.2379 58.0354 21.6859 58.0354H41.5513C41.9993 58.0354 42.37 57.6691 42.37 57.2167V54.9829L40.737 53.8348V56.3962H22.5098V52.6955H39.7672V51.0581H21.6859Z"
      //fill="#5B2540"
      className={primaryClassName1}
    />
    <path
      d="M51.123 33.3888L45.6883 37.3592C45.3589 37.5982 45.148 37.9083 45.0189 38.2473L42.8369 36.0609C42.7236 35.9415 42.5725 35.8686 42.4118 35.8449L39.3426 35.3977C38.8076 35.324 38.4176 35.7676 38.4914 36.248L38.9359 39.355C38.9534 39.5149 39.0272 39.666 39.1414 39.7854L41.0441 41.6934L41.4692 45.9019L41.3243 48.9394C41.2593 50.3264 41.3928 51.9366 42.6507 52.9108L51.499 59.7501C52.5452 60.5547 53.0178 61.0256 53.7038 62.1798C54.0192 62.706 54.3626 63.2225 54.692 63.7399C55.3974 64.9925 56.3031 65.7611 57.3826 65.8569C58.4622 65.9447 59.4829 65.4642 60.6679 64.7861L65.6037 61.9541C66.7843 61.2777 67.7172 60.6408 68.1889 59.6667C68.6589 58.6925 68.4806 57.5207 67.7717 56.2672L66.83 54.6061C66.0377 53.2287 66.0702 50.6989 65.8919 49.0194L65.3016 43.5758C65.118 41.9253 64.3678 40.5558 63.0282 39.6774C60.942 38.315 57.3545 36.5669 57.0849 36.4334L55.8805 34.3524C54.7518 32.4094 52.9264 32.0756 51.123 33.3888ZM54.5735 35.1123L58.9137 42.6298C59.4127 43.5047 60.7259 42.7448 60.2226 41.8708L58.4657 38.8227C59.7148 39.4824 61.2108 40.2967 62.1937 40.9414C63.182 41.5967 63.6484 42.4154 63.7907 43.7462L64.3863 49.1854C64.5593 50.7542 64.4583 52.8862 65.1909 54.6755L54.6033 60.7866C53.977 59.8678 53.3182 59.2459 52.4213 58.5502L43.5748 51.71C42.9467 51.2259 42.7737 50.2246 42.8334 49.0071L42.9845 45.9229L42.6173 42.1993C42.9327 42.2081 43.2401 42.108 43.5968 42.3864C44.1783 42.8441 44.9328 43.8648 45.4959 45.9001C45.5785 46.2111 45.719 46.3771 45.9167 46.5782L55.451 56.153C56.621 57.3336 58.1082 57.1368 59.1658 56.153C60.2823 55.1182 60.2006 53.4808 59.1606 52.4417L53.6704 46.9296C55.3087 45.6489 55.7672 43.6724 54.8923 42.1624L52.8887 38.6804C52.6963 38.3475 52.2843 38.2148 51.9277 38.3659L48.4562 39.9031C47.2668 40.4302 46.8232 40.0999 46.5755 39.6748C46.2645 39.1345 46.4516 38.6734 47.0199 38.2561L52.0155 34.6107C53.0863 33.8227 53.9691 34.0652 54.5735 35.1123ZM40.1305 37.0386L41.9453 37.3048L58.0959 53.509C58.4034 53.8164 58.4938 54.0773 58.4526 54.3382C58.3612 54.9698 57.8403 55.4397 57.3457 55.4397C57.0849 55.4397 56.8275 55.3896 56.5218 55.0831L46.933 45.4565C46.2742 43.2701 45.4783 41.9472 44.5314 41.2032C43.7162 40.5576 42.8018 40.4249 42.0147 40.5295L40.3914 38.8921L40.1305 37.0386ZM51.9189 40.027L53.5844 42.9188C54.1009 43.8147 53.9278 44.9453 52.5909 45.8465L48.2901 41.5317C48.5458 41.4764 48.8031 41.4044 49.064 41.2849L51.9189 40.027ZM65.8919 56.0124L66.4549 57.0156C67.04 58.0486 67.0505 58.5519 66.8309 59.0105C66.606 59.4673 65.9525 60.0171 64.8545 60.6479L59.9169 63.4799C58.8153 64.1062 58.009 64.3908 57.5118 64.3486C57.0128 64.3082 56.5956 64.0429 56.0106 63.009L55.4203 62.0612L65.8919 56.0124Z"
      //fill="#E87823"
      className={primaryClassName2}
    />
  </svg>
);

const EnrollmentLifeEventIconNew = ({
  primaryClassName1,
  primaryClassName2,
}) => (
  <svg
    width="48"
    height="66"
    viewBox="0 0 48 66"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.539 22.2472C20.718 21.2332 22.257 20.3572 24 20.3572C25.743 20.3572 27.282 21.2332 28.461 22.2472C29.0886 22.7872 29.6568 23.3926 30.156 24.0532L30.252 24.1912C30.389 24.3966 30.5746 24.5651 30.7923 24.6816C31.01 24.7981 31.2531 24.859 31.5 24.859C31.7469 24.859 31.99 24.7981 32.2077 24.6816C32.4254 24.5651 32.611 24.3966 32.748 24.1912L32.844 24.0532C33.3429 23.3914 33.9111 22.785 34.539 22.2442C35.718 21.2332 37.257 20.3572 39 20.3572C40.743 20.3572 42.282 21.2332 43.461 22.2472C44.0886 22.7872 44.6568 23.3926 45.156 24.0532L45.252 24.1912C45.4307 24.4592 45.6909 24.6625 45.9941 24.7711C46.2973 24.8798 46.6274 24.8879 46.9356 24.7944C47.2438 24.7008 47.5137 24.5106 47.7054 24.2517C47.8971 23.9929 48.0004 23.6793 48 23.3572C48 12.0292 38.328 0.857178 24 0.857178C9.672 0.857178 1.12709e-06 12.0292 1.12709e-06 23.3572C-0.000393584 23.6793 0.102893 23.9929 0.294581 24.2517C0.48627 24.5106 0.756179 24.7008 1.06438 24.7944C1.37258 24.8879 1.7027 24.8798 2.00591 24.7711C2.30913 24.6625 2.56932 24.4592 2.748 24.1912L2.844 24.0532C3.34294 23.3915 3.91117 22.7851 4.539 22.2442C5.718 21.2362 7.257 20.3572 9 20.3572C10.743 20.3572 12.282 21.2332 13.461 22.2472C14.0887 22.7871 14.6569 23.3926 15.156 24.0532L15.252 24.1882C15.389 24.3936 15.5746 24.5621 15.7923 24.6786C16.01 24.7951 16.2531 24.856 16.5 24.856C16.7469 24.856 16.99 24.7951 17.2077 24.6786C17.4254 24.5621 17.611 24.3936 17.748 24.1882L17.844 24.0532C18.3429 23.3915 18.9112 22.7851 19.539 22.2442V22.2472Z"
      //fill="#E87823"
      className={primaryClassName2}
    />
    <path
      d="M8.57129 33.0026C8.57129 34.973 10.1719 36.5714 12.1427 36.5714C14.1136 36.5714 15.7141 34.9713 15.7141 33.0026C15.7141 31.0253 14.1136 29.4286 12.1427 29.4286C10.1719 29.4286 8.57129 31.027 8.57129 33.0026Z"
      //fill="#5B2540"
      className={primaryClassName1}
    />
    <path
      d="M30 33.0026C30 34.973 31.6023 36.5714 33.5732 36.5714C35.544 36.5714 37.1429 34.9713 37.1429 33.0026C37.1429 31.0253 35.544 29.4286 33.5732 29.4286C31.6023 29.4286 30 31.027 30 33.0026Z"
      //fill="#5B2540"
      className={primaryClassName1}
    />
    <path
      d="M22.8571 42.2857C24.4351 42.2857 25.7143 41.0065 25.7143 39.4286C25.7143 37.8506 24.4351 36.5714 22.8571 36.5714C21.2792 36.5714 20 37.8506 20 39.4286C20 41.0065 21.2792 42.2857 22.8571 42.2857Z"
      //fill="#5B2540"
      className={primaryClassName1}
    />
    <path
      d="M28.5711 53.3401V46.0169C28.5711 45.1801 27.2239 43.7144 25.0241 43.7144H22.8569H20.6896C18.4915 43.7144 17.1426 45.1801 17.1426 46.0169V53.3401C17.1426 54.245 18.3426 54.9617 19.1558 55.1355V63.2042C19.1558 64.2757 19.9809 65.1429 21.0063 65.1429C22.0283 65.1429 22.8569 64.2757 22.8569 63.2042C22.8569 64.2757 23.6854 65.1429 24.7091 65.1429C25.7328 65.1429 26.5597 64.2757 26.5597 63.2042V55.1355C27.3711 54.9635 28.5711 54.245 28.5711 53.3401Z"
      //fill="#5B2540"
      className={primaryClassName1}
    />
    <path
      d="M18.5716 43.4558L16.4887 40.1883C16.0647 39.5229 14.4091 39.4286 14.3196 39.4286H9.07605C8.98652 39.4286 7.33101 39.5229 6.90531 40.1883L1.7158 48.3301C1.18705 49.1596 1.41003 50.2686 2.20907 50.8135C3.00811 51.3601 4.0825 51.1313 4.61125 50.3035L7.21614 46.2187V62.8254C7.21614 64.1038 8.21789 65.1429 9.45614 65.1429C10.6927 65.1429 11.6961 64.1038 11.6961 62.8254C11.6961 64.1038 12.6996 65.1429 13.9378 65.1429C15.1744 65.1429 16.1778 64.1038 16.1778 62.8254V54.9106C15.9312 54.5456 15.7724 54.123 15.7724 53.6392V46.5016C15.7741 45.3105 16.8958 44.0164 18.5716 43.4558Z"
      //fill="#5B2540"
      className={primaryClassName1}
    />
    <path
      d="M43.9991 48.3301L38.811 40.1883C38.3819 39.5229 36.7297 39.4286 36.6402 39.4286H31.3964C31.3069 39.4286 29.653 39.5229 29.2256 40.1883L27.1426 43.4558C28.8201 44.0147 29.9419 45.3105 29.9419 46.5016V53.6392C29.9419 54.8757 28.9232 55.7332 27.9569 56.1698V56.4964H29.5364V62.8254C29.5364 64.1038 30.5399 65.1429 31.7765 65.1429C33.0131 65.1429 34.0183 64.1038 34.0183 62.8254C34.0183 64.1038 35.0201 65.1429 36.2601 65.1429C37.4967 65.1429 38.4968 64.1038 38.4968 62.8254V56.4964H40.9396L38.4968 46.2187L41.1018 50.3035C41.6306 51.1313 42.7067 51.3584 43.5058 50.8135C44.3049 50.2704 44.5262 49.1596 43.9991 48.3301Z"
      //fill="#5B2540"
      className={primaryClassName1}
    />
    <rect
      x="21.4287"
      y="25.1429"
      width="2.85714"
      height="8.57143"
      rx="1.42857"
      //fill="#E87823"
      className={primaryClassName2}
    />
  </svg>
);

const ProductIcon = ({ classNameSecondary, classNamePrimary }) => (
  <svg
    width="64"
    height="65"
    viewBox="0 0 64 65"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="health Icon">
      <g id="Group">
        <path
          id="Vector"
          d="M40.2608 29.0266H35.4901V24.3304C35.4901 23.4705 34.8182 22.8091 33.9447 22.8091H31.1897C30.3162 22.8091 29.6443 23.4705 29.6443 24.3304V29.0266H24.8736C24.0001 29.0266 23.3281 29.688 23.3281 30.5479V33.2597C23.3281 34.1196 24.0001 34.781 24.8736 34.781H29.6443V39.4772C29.6443 40.3371 30.3162 40.9985 31.1897 40.9985H33.8775C34.751 40.9985 35.4229 40.3371 35.4229 39.4772V34.781H40.1937C41.0672 34.781 41.7391 34.1196 41.7391 33.2597V30.614C41.8063 29.7541 41.1344 29.0266 40.2608 29.0266Z"
          //fill="#E6DEE2"
          className={classNameSecondary}
        />
        <path
          id="Vector_2"
          d="M58.9396 17.8481C58.9396 16.2606 58.8724 14.7393 58.8724 13.2842V11.7629C58.8724 10.7707 58.066 9.97701 57.0581 9.97701H55.5127C46.7776 9.97701 40.3942 7.59585 34.8171 2.30437L33.742 1.24608C33.0701 0.584641 31.9278 0.584641 31.2559 1.24608L30.1808 2.30437C24.6709 7.59585 18.2876 9.97701 9.48525 9.97701H7.9398C6.9319 9.97701 6.12558 10.7707 6.12558 11.7629V13.2842C6.12558 14.7393 6.12558 16.2606 6.05839 17.8481C5.78962 33.0611 5.38645 53.9624 31.3903 62.8256C32.1294 63.0902 32.8685 63.0902 33.6077 62.8256C59.6787 53.9624 59.2083 33.1272 58.9396 17.8481Z"
          fill="#E6DEE2"
        />
        <path
          id="Vector_3"
          d="M39.6953 19C36.9836 19 34.3861 20.1206 32.5 22.0999C30.6139 20.1206 28.0164 19 25.3047 19C20.6482 19 17 23.1211 17 28.376C17 32.0628 18.9481 39.244 32.004 45.8782C32.3172 46.0406 32.686 46.0406 32.9993 45.8782C46.0519 39.244 48 32.0628 48 28.376C48 23.1211 44.3518 19 39.6953 19ZM40.25 33.6244H37.6786L35.7436 38.5411C35.5739 38.9721 35.166 39.2506 34.7157 39.2506C34.2621 39.2506 33.8542 38.9721 33.6845 38.5411L30.2843 29.9044L29.0998 32.9182C28.9301 33.3459 28.5255 33.6244 28.0719 33.6244H24.75C24.1398 33.6244 23.6438 33.1204 23.6438 32.5004C23.6438 31.8771 24.1398 31.3765 24.75 31.3765H27.3214L29.2564 26.4564C29.4261 26.0287 29.834 25.7469 30.2843 25.7469C30.7379 25.7469 31.1458 26.0287 31.3155 26.4564L34.7157 35.0964L35.9002 32.0827C36.0699 31.655 36.4745 31.3732 36.9281 31.3765H40.25C40.8602 31.3765 41.3562 31.8771 41.3562 32.5004C41.3562 33.1204 40.8602 33.6244 40.25 33.6244Z"
          //fill="#5B2540"
          className={classNamePrimary}
        />
      </g>
    </g>
  </svg>
);

const ProductDentalIcon = ({ classNameSecondary, classNamePrimary }) => (
  <svg
    width="53"
    height="63"
    viewBox="0 0 53 63"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M52.9396 17.0981C52.9396 15.5106 52.8724 13.9893 52.8724 12.5342V11.0129C52.8724 10.0207 52.066 9.22701 51.0581 9.22701H49.5127C40.7776 9.22701 34.3942 6.84585 28.8171 1.55437L27.742 0.496076C27.0701 -0.165359 25.9278 -0.165359 25.2559 0.496076L24.1808 1.55437C18.6709 6.84585 12.2876 9.22701 3.48525 9.22701H1.9398C0.931902 9.22701 0.125582 10.0207 0.125582 11.0129V12.5342C0.125582 13.9893 0.125582 15.5106 0.0583889 17.0981C-0.210384 32.3111 -0.613546 53.2124 25.3903 62.0756C26.1294 62.3402 26.8685 62.3402 27.6077 62.0756C53.6787 53.2124 53.2083 32.3772 52.9396 17.0981Z"
      //fill="#E6DEE2"
      className={classNameSecondary}
    />
    <path
      d="M22.1172 45.7895C18.7272 45.7895 16.9172 39.1495 16.0172 35.8695C15.8972 35.4295 15.7972 35.0695 15.7172 34.8095C15.5872 34.3795 15.4172 33.8695 15.2272 33.2995C14.2972 30.5295 12.8872 26.2995 13.0072 22.9195C13.0872 20.5595 13.8872 18.9195 15.3772 17.9195C17.9972 16.2495 20.4872 17.1895 22.8872 18.1095C23.3372 18.2795 23.7972 18.4495 24.2472 18.5995C25.5974 19.0494 27.057 19.0494 28.4072 18.5995C28.8572 18.4495 29.3172 18.2795 29.7672 18.1095C32.1672 17.1995 34.6572 16.2495 37.2772 17.9195C38.7672 18.8595 39.5672 20.5295 39.6472 22.9195C39.7672 26.3495 38.3572 30.5395 37.4272 33.3095C37.2372 33.8795 37.0672 34.3895 36.9372 34.8195C36.8572 35.0795 36.7572 35.4395 36.6372 35.8795C35.6872 39.3495 33.7272 46.5595 29.9372 45.7295C27.5772 45.2095 27.6672 41.9095 27.7372 38.9995C27.7872 36.9995 27.8372 34.9995 27.1172 34.2195C27.0156 34.118 26.8934 34.0396 26.7588 33.9895C26.6242 33.9395 26.4804 33.919 26.3372 33.9295C26.194 33.919 26.0502 33.9395 25.9156 33.9895C25.781 34.0396 25.6588 34.118 25.5572 34.2195C24.8372 34.9595 24.8872 37.0195 24.9372 38.9995C25.0072 41.9095 25.0972 45.2095 22.7372 45.7295C22.5331 45.7705 22.3254 45.7906 22.1172 45.7895Z"
      //fill="#5B2540"
      className={classNamePrimary}
    />
  </svg>
);

const ProductVisionIcon = ({ classNameSecondary, classNamePrimary }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
  >
    <path
      d="M58.9396 17.0981C58.9396 15.5106 58.8724 13.9893 58.8724 12.5342V11.0129C58.8724 10.0207 58.066 9.22701 57.0581 9.22701H55.5127C46.7776 9.22701 40.3942 6.84585 34.8171 1.55437L33.742 0.496076C33.0701 -0.165359 31.9278 -0.165359 31.2559 0.496076L30.1808 1.55437C24.6709 6.84585 18.2876 9.22701 9.48525 9.22701H7.9398C6.9319 9.22701 6.12558 10.0207 6.12558 11.0129V12.5342C6.12558 13.9893 6.12558 15.5106 6.05839 17.0981C5.78962 32.3111 5.38645 53.2124 31.3903 62.0756C32.1294 62.3402 32.8685 62.3402 33.6077 62.0756C59.6787 53.2124 59.2083 32.3772 58.9396 17.0981Z"
      //fill="#E6DEE2"
      className={classNameSecondary}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M47.8296 33.721C44.367 38.7414 38.7904 42 32.4999 42C26.2093 42 20.6327 38.7414 17.1702 33.721C16.9433 33.3917 16.9433 32.9871 17.1702 32.6582C20.6327 27.6378 26.2093 24.3792 32.4999 24.3792C38.7904 24.3792 44.367 27.6378 47.8296 32.6578C48.0568 32.9871 48.0568 33.3921 47.8296 33.721ZM23.9349 20.1441C23.6067 19.8601 23.5799 19.3745 23.8755 19.0588C24.1711 18.7434 24.6765 18.7177 25.0051 19.0017L27.2809 20.9704C27.6092 21.2544 27.6359 21.74 27.3403 22.0558C27.0448 22.3712 26.5394 22.3969 26.2108 22.1129L23.9349 20.1441ZM39.995 19.002C40.3233 18.718 40.829 18.7437 41.1246 19.0591C41.4202 19.3745 41.3934 19.8605 41.0652 20.1445L38.7893 22.1132C38.4611 22.3972 37.9553 22.3716 37.6598 22.0562C37.3642 21.7408 37.3909 21.2548 37.7192 20.9708L39.995 19.002ZM33.3008 19.6885C33.3008 20.1134 32.9421 20.4581 32.4999 20.4581C32.0576 20.4581 31.6989 20.1134 31.6989 19.6885V16.7696C31.6989 16.3447 32.0576 16 32.4999 16C32.9421 16 33.3008 16.3447 33.3008 16.7696V19.6885ZM30.8111 30.2324C30.1661 30.2324 29.6433 30.7347 29.6433 31.3545C29.6433 31.9742 30.1661 32.4766 30.8111 32.4766C31.4561 32.4766 31.9789 31.9742 31.9789 31.3545C31.9789 30.7347 31.4561 30.2324 30.8111 30.2324ZM32.4999 26.8211C30.6696 26.8211 29.0128 27.5339 27.8134 28.6864C26.614 29.8388 25.8721 31.4312 25.8721 33.1894C25.8721 34.948 26.614 36.54 27.8134 37.6925C29.0128 38.8449 30.67 39.5578 32.4999 39.5578C34.3301 39.5578 35.987 38.8449 37.1863 37.6925C38.3857 36.54 39.1276 34.9477 39.1276 33.1894C39.1276 31.4308 38.3857 29.8388 37.1863 28.6864C35.987 27.5339 34.3301 26.8211 32.4999 26.8211ZM36.0538 29.7746C35.1444 28.9008 33.8879 28.3603 32.4999 28.3603C31.1119 28.3603 29.8553 28.9008 28.9456 29.7746C28.0362 30.6484 27.4736 31.8557 27.4736 33.1898C27.4736 34.5235 28.0362 35.7308 28.9456 36.6046C29.8549 37.4784 31.1115 38.0189 32.4999 38.0189C33.8879 38.0189 35.1444 37.4784 36.0538 36.6046C36.9632 35.7308 37.5257 34.5235 37.5257 33.1898C37.5261 31.8557 36.9635 30.6484 36.0538 29.7746Z"
      //fill="#5B2540"
      className={classNamePrimary}
    />
  </svg>
);

const EnrollPlusIcon = ({ className }) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 0.5C3.58473 0.5 0 4.08473 0 8.5C0 12.9153 3.58473 16.5 8 16.5C12.4153 16.5 16 12.9153 16 8.5C16 4.08473 12.4153 0.5 8 0.5ZM7.27273 7.77273H5.09091C4.68945 7.77273 4.36364 8.09855 4.36364 8.5C4.36364 8.90145 4.68945 9.22727 5.09091 9.22727H7.27273V11.4091C7.27273 11.8105 7.59855 12.1364 8 12.1364C8.40145 12.1364 8.72727 11.8105 8.72727 11.4091V9.22727H10.9091C11.3105 9.22727 11.6364 8.90145 11.6364 8.5C11.6364 8.09855 11.3105 7.77273 10.9091 7.77273H8.72727V5.59091C8.72727 5.18945 8.40145 4.86364 8 4.86364C7.59855 4.86364 7.27273 5.18945 7.27273 5.59091V7.77273Z"
      //fill="#007E33"
      className={className}
    />
  </svg>
);

const EnrollMinusIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
  >
    <path
      d="M8 0.5C6.41775 0.5 4.87103 0.969192 3.55544 1.84824C2.23985 2.72729 1.21447 3.97672 0.608967 5.43853C0.00346625 6.90034 -0.15496 8.50887 0.153721 10.0607C0.462403 11.6126 1.22433 13.038 2.34315 14.1569C3.46197 15.2757 4.88743 16.0376 6.43928 16.3463C7.99113 16.655 9.59966 16.4965 11.0615 15.891C12.5233 15.2855 13.7727 14.2602 14.6518 12.9446C15.5308 11.629 16 10.0822 16 8.5C15.9977 6.37896 15.1541 4.34545 13.6543 2.84565C12.1546 1.34585 10.121 0.502269 8 0.5ZM12.4286 10.0714H3.57143V6.92857H12.4286V10.0714Z"
      //fill="#007399"
      className={className}
    />
  </svg>
);

const EditIcon = ({ fillColor = '#60034C' }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.27473 15.1111C1.89362 15.1111 1.56726 14.9756 1.29563 14.7044C1.02401 14.4332 0.888425 14.1069 0.888887 13.7253V4.02439C0.888887 3.64328 1.0247 3.31691 1.29632 3.04529C1.56795 2.77366 1.89408 2.63808 2.27473 2.63854H8.45906L7.07321 4.02439H2.27473V13.7253H11.9756V8.90948L13.3615 7.52364V13.7253C13.3615 14.1064 13.2257 14.4328 12.954 14.7044C12.6824 14.976 12.3563 15.1116 11.9756 15.1111H2.27473ZM10.0181 3.03697L11.0055 4.00706L6.43226 8.58035V9.56776H7.40235L11.993 4.97715L12.9804 5.94725L8.38976 10.5379C8.26273 10.6649 8.11537 10.7661 7.94768 10.8414C7.77999 10.9166 7.60399 10.9541 7.41967 10.9536H5.73934C5.54301 10.9536 5.37833 10.8871 5.24528 10.754C5.11224 10.621 5.04595 10.4565 5.04642 10.2607V8.58035C5.04642 8.39557 5.08106 8.21934 5.15035 8.05165C5.21965 7.88396 5.31781 7.73683 5.44485 7.61026L10.0181 3.03697ZM12.9804 5.94725L10.0181 3.03697L11.7504 1.30467C12.0276 1.0275 12.3597 0.888916 12.7469 0.888916C13.134 0.888916 13.4601 1.0275 13.7253 1.30467L14.6953 2.29208C14.961 2.5577 15.0938 2.88107 15.0938 3.26217C15.0938 3.64328 14.961 3.96664 14.6953 4.23226L12.9804 5.94725Z"
        fill={fillColor}
      />
    </svg>
  );
};

const UnselectedRadioButtonSvg = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <path
        d="M15 1.875C12.4041 1.875 9.86654 2.64477 7.70815 4.08696C5.54975 5.52916 3.86749 7.579 2.87409 9.97728C1.88069 12.3756 1.62077 15.0146 2.1272 17.5606C2.63363 20.1066 3.88367 22.4452 5.71923 24.2808C7.55479 26.1163 9.89345 27.3664 12.4394 27.8728C14.9854 28.3792 17.6244 28.1193 20.0227 27.1259C22.421 26.1325 24.4708 24.4503 25.913 22.2919C27.3552 20.1335 28.125 17.5959 28.125 15C28.125 11.519 26.7422 8.18064 24.2808 5.71922C21.8194 3.25781 18.481 1.875 15 1.875Z"
        //fill="#E7E7E7"
        className={className}
      />
    </svg>
  );
};

const CloseCoverageIcon = ({ className }) => {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Group 172">
        <rect
          id="Rectangle 129"
          width="21.3666"
          height="3.90824"
          transform="matrix(0.713477 0.700679 -0.705027 0.70918 2.75586 0.5)"
          //fill="#263154"
          className={className}
        />
        <rect
          id="Rectangle 130"
          width="21.3651"
          height="3.90853"
          transform="matrix(-0.705027 0.70918 -0.713477 -0.700679 17.9258 3.34766)"
          //fill="#263154"
          className={className}
        />
      </g>
    </svg>
  );
};

const CoverageBackIcon = ({ className }) => {
  return (
    <svg
      width="38"
      height="37"
      viewBox="0 0 38 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="icon">
        <path
          id="Vector"
          d="M26.6667 17.8479H6.38333L15.7 8.77644L13.3333 6.48828L0 19.4707L13.3333 32.4532L15.6833 30.165L6.38333 21.0935H26.6667V17.8479Z"
          className={className}
        />
      </g>
    </svg>
  );
};

const SelectedRadioButtonSVG = ({ classNamePrimary, classNameSecondary }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="31"
      viewBox="0 0 30 31"
      fill="none"
    >
      <path
        d="M0.5 15.5C0.5 7.49489 6.99489 1 15 1C23.0051 1 29.5 7.49489 29.5 15.5C29.5 23.5051 23.0051 30 15 30C6.99489 30 0.5 23.5051 0.5 15.5Z"
        //fill="#007E33"
        //stroke="#007E33"
        className={classNamePrimary}
      />
      <path
        d="M13.7598 22.0312L22.5723 13.1875C23.1973 12.5625 23.1973 11.5938 22.6035 10.9688C21.9785 10.3438 21.0098 10.3438 20.3848 10.9688L12.666 18.6875L9.35352 15.375C8.72852 14.75 7.75977 14.75 7.13477 15.375C6.50977 16 6.50977 16.9688 7.13477 17.5938L11.5723 22.0312C11.8535 22.3438 12.2598 22.5 12.666 22.5C13.0723 22.5 13.4785 22.3125 13.7598 22.0312Z"
        //fill="white"
        className={classNameSecondary}
      />
    </svg>
  );
};

const EnrollCoveragePlusIcon = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 0.5C3.58473 0.5 0 4.08473 0 8.5C0 12.9153 3.58473 16.5 8 16.5C12.4153 16.5 16 12.9153 16 8.5C16 4.08473 12.4153 0.5 8 0.5ZM7.27273 7.77273H5.09091C4.68945 7.77273 4.36364 8.09855 4.36364 8.5C4.36364 8.90145 4.68945 9.22727 5.09091 9.22727H7.27273V11.4091C7.27273 11.8105 7.59855 12.1364 8 12.1364C8.40145 12.1364 8.72727 11.8105 8.72727 11.4091V9.22727H10.9091C11.3105 9.22727 11.6364 8.90145 11.6364 8.5C11.6364 8.09855 11.3105 7.77273 10.9091 7.77273H8.72727V5.59091C8.72727 5.18945 8.40145 4.86364 8 4.86364C7.59855 4.86364 7.27273 5.18945 7.27273 5.59091V7.77273Z"
        //fill="#007E33"
        className={className}
      />
    </svg>
  );
};

export {
  AccordionUpArrow,
  AccordionDownArrow,
  NavigationStepsActiveSVG,
  NavigationStepsSuccessSVG,
  NavigationStepsBeforeActiveSVG,
  PlusSVG,
  EnrollmentLifeEventIcon,
  EnrollmentLifeEventIconNew,
  ProductIcon,
  ProductDentalIcon,
  ProductVisionIcon,
  EnrollPlusIcon,
  EnrollMinusIcon,
  EditIcon,
  UnselectedRadioButtonSvg,
  CloseCoverageIcon,
  CoverageBackIcon,
  SelectedRadioButtonSVG,
  EnrollCoveragePlusIcon,
};
